// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableReportObject {
    background: white;
}

.Formula{
    border:1px solid black;
}
.Value{
    padding-left:5px;
    padding-right:5px;
}
.sheetcontainer{
    height:35px;
}

.selection {
    background-color: #97bf0d;
    color: white;
}
.selection:hover {
    background-color: grey!important;
    color:white;
}
.sheet {
    padding: 5px;
    cursor: pointer;
    align-items: center;
    display: flex;
    width: 100px;
    border: 0.5px solid gray;
    border-radius: 0 0 5px 5px;
}

.sheet:hover {
    background-color: #97bf0d;
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/reportobjectcontrols/planning/planning.reportobject.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,gCAAgC;IAChC,WAAW;AACf;AACA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB","sourcesContent":[".TableReportObject {\n    background: white;\n}\n\n.Formula{\n    border:1px solid black;\n}\n.Value{\n    padding-left:5px;\n    padding-right:5px;\n}\n.sheetcontainer{\n    height:35px;\n}\n\n.selection {\n    background-color: #97bf0d;\n    color: white;\n}\n.selection:hover {\n    background-color: grey!important;\n    color:white;\n}\n.sheet {\n    padding: 5px;\n    cursor: pointer;\n    align-items: center;\n    display: flex;\n    width: 100px;\n    border: 0.5px solid gray;\n    border-radius: 0 0 5px 5px;\n}\n\n.sheet:hover {\n    background-color: #97bf0d;\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
